import React, { useMemo, useState } from 'react';
import { Box, Grid} from '@material-ui/core';
import { TimeSlotsGrid } from './timeSlotsGrid.component';
import { ActivityFilter } from '../../../reservations/filters/ActivityFilter.component';
import { EditTimeSlot } from './editTimeSlot.component';
import dayjs from 'dayjs';

/**
 * Vue de gestion des créneaux horaires d'activités supervisées
 * 
 * Cette vue permet de :
 * - Consulter et gérer les créneaux horaires des activités supervisées
 * - Filtrer par activité spécifique
 * - Créer et modifier des créneaux horaires
 * - Gérer les réservations et contraintes par créneau
 * 
 * Logique métier :
 * - Filtrage des activités par type "supervised"
 * - Gestion des créneaux avec départ et arrivée
 * - Contrôle des capacités (maxPeople, maxPeopleWithMonitor)
 * - Gestion des contraintes de réservation
 * - Rafraîchissement automatique après modifications
 * 
 * @returns Composant React de la vue des créneaux horaires
 */
export function TimeSlotsView() {

  /**
   * Activité par défaut pour l'initialisation
   */
  const defaultActivity: CRM.ActivityDocument = {
    _id: ''
  } as any;
  
  /**
   * Créneau horaire par défaut avec valeurs initiales
   */
  const defaultActivityTimeSlot: CRM.ActivityTimeSlotDetailed = {
    _id: '',
    domain: '',
    activity: defaultActivity,
    timeSlotDeparture: new Date(),//#TODO replace by other form fields
    timeSlotArrival: new Date(),
    bookedPeople: 0,
    bookedPeopleWithMonitor: 0,
    maxPeople: 16,
    maxPeopleWithMonitor: 4,
    minAutonomousPeople: 3,
    constrainReservations: true,
    closeReservations: false,
    monitor: 'bruno'
  }
  
  /**
   * États locaux pour la gestion des créneaux horaires
   */
  //const [timeSlotId, setTimeSlotId] = useState<string>();
  const [selectedActivities, setSelectedActivities] = useState<string[]>([]);
  const [selectedActivityTimeSlot, setSelectedActivityTimeSlot] = useState<CRM.ActivityTimeSlotDetailed>(defaultActivityTimeSlot);
  const [refresh, setRefresh] = useState<number>(0);
  const [createtimeSlotsDates, setCreateTimeSlotsDates] = useState<Date[]>([dayjs().add(1,'day').toDate()]);

  /**
   * Calcul des dates min et max pour l'année courante
   * Utilisé pour limiter la sélection de dates dans les composants
   */
  const { minDate, maxDate } = useMemo(() => {
    const thisYear = dayjs().year(new Date().getFullYear());
    return {
      minDate: thisYear.startOf('year'),
      maxDate: thisYear.endOf('year'),
    };
  }, []);
  
  return (
    <div>
      <Box
        display={'flex'}
        justifyContent={'flex-end'}
        alignItems={'center'}
        mb={3}
      >
        <Grid container spacing={2} item xs={12}>
        { selectedActivityTimeSlot && selectedActivityTimeSlot.activity._id !== '' && 
        <Grid item xs={12} sm={12}>
            <EditTimeSlot
              setCreateTimeSlotsDates={setCreateTimeSlotsDates}
              createtimeSlotsDates={createtimeSlotsDates}
              setSelectedActivityTimeSlot={setSelectedActivityTimeSlot}
              selectedActivityTimeSlot={selectedActivityTimeSlot}
              //setTimeSlotId={setTimeSlotId}
              //timeSlotId={timeSlotId}
              minDate={minDate}
              maxDate={maxDate}
              onSave={() => { setRefresh(refresh + 1); }}
              callRefresh={() => { 
                setSelectedActivityTimeSlot(defaultActivityTimeSlot);
                setRefresh(refresh + 1); 
              }}
            />
          </Grid>
          }
          <Box mt={3} width='100%'>
            <Grid item xs={12} sm={12}>
              <ActivityFilter
                value={selectedActivities}
                onChange={setSelectedActivities}
                nowrapLabels={true}
                kindFilter={['supervised']}
              />
            </Grid>
            <Grid item xs={12}>
              <TimeSlotsGrid
                //onChange={(t) => { setSelectedActivityTimeSlot(t); setTimeSlotId(t._id); }}
                setSelectedActivityTimeSlot={setSelectedActivityTimeSlot}
                selectedActivityTimeSlot={selectedActivityTimeSlot}
                activitiesIdFilter={selectedActivities}
                allowDelete={false}
                allowCreate={true}
                refresh={refresh}
              />
            </Grid>
          </Box>
        </Grid>
      </Box>
    </div>
  );
}
